const labelMap = (map) => ({ value }) => {
  if (value == null) {
    return map.default ?? null;
  }

  return map[value] ?? map.default ?? null;
};

export default labelMap;
